module.exports = __webpack_public_path__ + "static/img/身份管理.b75ffbb6.png";